import HeaderLogo from "../HeaderLogo";

function MobileNotAvailable() {
    return (
        <>
            <HeaderLogo />

            <div className="flex flex-col items-center justify-center h-screen p-10">
                Sorry this feature isn't available on mobile devices.
                For the full user experience, please access it from a desktop or tablet (screen width 500px or greater).
            </div>
        </>
    )
}

export default MobileNotAvailable;